// extracted by mini-css-extract-plugin
module.exports = {"headerUserPicture":"styles_headerUserPicture__U4YyV","headerUserPictureLink":"styles_headerUserPictureLink__TMNoG"};